const theme = {
  primaryColor: "#2196F3",
  accentColor: "#FF0266",
  primaryTextColor: "white",
  accentTextColor: "white",
  errorRedColor: "#EC473F",
  warningYellowColor: "#f1c40f",
  lightGreyColor: "#f4f5f7",
  extraLightGreyColor: "#f9fafb",
  background: "#1c64f2",
  auth:
    "url(https://images.unsplash.com/photo-1517487881594-2787fef5ebf7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=675&q=80)",
  blueColor: "#1c64f2",
  maxWidth: "1080px",
  hoverBlueColor: "#3f83f8",
  greenColor: "#1abc9c",
  greyColor: "#7f8c8d",
  redColor: "#EC473F",
  yellowColor: "#f1c40f",
  darkBlueColor: "#19262B",
  darkGreyColor: "#364152",
  lightTextGreyColor: "#9FA6B2",
  mediumGreyColor: "#858789",
  screenWidth: "1080px",
  boxShadow: " 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);",
  description: `
    color: #9FA6B2;
    font-weight: 500;
  `,
  title: `
    font-weight: 500;
    color: #19262B;
    font-size: 1.125rem;
    line-height: 1.5rem;
  `,
  whiteBox: `
    background-color: white;
    border-radius: .375rem;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  `,
  pageContainer: `
  width: 100%;
  height: 100%;
  display: flex;
  padding: 1rem;
  flex-direction: column;
  padding-bottom: 20vh;
  `,
  loadingContainer: `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem;
  `,
};

export default theme;
